import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Download, Paperclip, Trash2 } from 'lucide-react';
import DeleteFileButton from '../DeleteFileButton';
import Upload from "rc-upload";
import { storageDownload } from '../../services/storageService';
const FileField = ({
  name,
  value,
  path: pathProp,
  onDeleteConfirm,
  onChange,
  readOnly
}) => {
  const [file, setFile] = useState(value);
  const [path, setPath] = useState(pathProp);
  const [isDelete, setIsDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = () => {
    setIsDelete(true);
    setPath(null);
    onDeleteConfirm && onDeleteConfirm();
  }

  const handleRemoveFile = () => {
    setFile(null);
  }

  const handleUpload = (file) => {
    setFile(file);
  }

  const handleDownload = () => {
    setLoading(true);
    storageDownload({ path })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    onChange && onChange({ name, value: file });
  }, [file]);

  useEffect(() => {
    onDeleteConfirm && onDeleteConfirm({ name: `${name}_delete`, value: isDelete });
  }, [isDelete]);

  if (path) {
    return (
      <div className="flex items-center space-x-2">
        <Button
          onClick={handleDownload}
          loading={loading}
          size="sm"
          className="max-w-[200px]"
        >
          <Download className="w-4 h-4 mr-2" />
          Descargar archivo
        </Button>
        {!readOnly && <DeleteFileButton onDeleteConfirm={handleDelete} disabled={loading} />}
      </div>
    )
  }

  return (
    <div className="flex items-center space-x-2">
      {!file && (
        <Upload multiple={false} action={handleUpload}>
          <Button
            type="button"
            size="sm"
            className="max-w-[200px]"
          >
            <Paperclip className="w-4 h-4 mr-2" />
            Seleccionar archivo
          </Button>
        </Upload>
      )}
      {file?.name && <span className="mx-2 min-w-0 truncate text-sm" title={file.name}>{file.name}</span>}
      {file && (
        <Button
          variant="destructive"
          size="sm"
          onClick={handleRemoveFile}
          className="mx-2"
        >
          <Trash2 className="w-4 h-4" />
        </Button>
      )}
      {isDelete && (
        <span className="mx-2 text-red-600 text-sm">
          Se borrará el archivo anterior
        </span>
      )}
    </div>
  );
}

export default FileField;